export const ROUTE_KEY = 'bankAccounts';
export const ROUTE_PATH = '/user/bankAccounts';
export const TITLE_ID = 'page.user.bankAccounts.title';
